/*
 * Author: Harper Yan
 * File Created: Friday, 24-07-12 11:02 am
 * Last Modified: Wednesday, 24-08-07 01:58 pm, by Roger
 */

import { Breakpoint, useTheme } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';

export const useScreenSize = (size: Breakpoint) => {
  const theme = useTheme();

  return useMediaQuery(theme.breakpoints.only(size));
};

export const useScreenPlan = (size: Breakpoint) => {
  const theme = useTheme();

  return useMediaQuery(theme.breakpoints.down(size));
};
